export enum ConditionsEnum {
  AND = '&',
  OR = '§',
}

export enum OperatorsEnum {
  Is = 'Is',
  Is_NOT = 'Is NOT',
}

export enum ISVariableValueEnum {
  Active = 'Active',
}
